import { render } from "./MarkdownComponent.vue?vue&type=template&id=1a2dff6a"
import script from "./MarkdownComponent.vue?vue&type=script&lang=js"
export * from "./MarkdownComponent.vue?vue&type=script&lang=js"

import "./MarkdownComponent.vue?vue&type=style&index=0&id=1a2dff6a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__